import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-board",
  "use": "icon-si-glyph-board-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-board\" id=\"icon-si-glyph-board\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>852</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M15,2 L3,2 C1.896,2 1,2.896 1,4 L1,11 C1,12.104 1.896,13 3,13 L15,13 C16.104,13 17,12.104 17,11 L17,4 C17,2.896 16.104,2 15,2 L15,2 Z M5,10 L4,10 L4,7 L3,7 L3,6 L4,6 L5,6 L5,10 L5,10 Z M9,8 L8,8 L8,9 L7,9 L7,8 L6,8 L6,7 L7,7 L7,6 L8,6 L8,7 L9,7 L9,8 L9,8 Z M12,10 L11,10 L11,7 L10,7 L10,6 L11,6 L12,6 L12,10 L12,10 Z M15,9 L13,9 L13,8 L15,8 L15,9 L15,9 Z M15,7 L13,7 L13,6 L15,6 L15,7 L15,7 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-board.svg
// module id = 5qlC
// module chunks = 62